module.exports = __webpack_public_path__ + "static/media/logo-호두랩스@2x.09528eca.png";